module.exports = __webpack_public_path__ + "media/succeed.ff8a9f67.mp3";